/* ============================================================
   CULT RACING — PRODUCT SHOT SWIPER  (page-neutral)

   Pairs with assets/cr-shots.css. Loads AFTER drop-page.js and
   touches nothing that file owns: no cart, no add-to-cart, no
   reveal. Everything here is new surface.

   🔴 THE SWIPE ITSELF IS NOT IN THIS FILE. It is native CSS
   scroll-snap. This script only draws the dots, keeps the counter
   honest, moves the track when a dot is pressed, and stops a swipe
   from being mistaken for a tap. If this script never loads the
   strip still swipes perfectly, it just has no dots. That is the
   right failure mode and it is the same reasoning as the
   personalization field, where the gate is native validation.

   Driven by data attributes, so any page that renders them gets it:
     [data-shots]        the wrapper
     [data-shots-track]  the scrolling track; its children are slides
     [data-shots-nav]    where the dots and counter are written

   Markup for the nav is BUILT HERE rather than in Liquid, because
   the count has to match the number of slides and a product can
   gain a photo at any time. Nothing else is injected.
   ============================================================ */
(function () {
  "use strict";

  var groups = [].slice.call(document.querySelectorAll("[data-shots]"));
  if (!groups.length) return;

  groups.forEach(function (root) {
    var track = root.querySelector("[data-shots-track]");
    var nav = root.querySelector("[data-shots-nav]");
    if (!track) return;

    var slides = [].slice.call(track.children);
    /* one photo is not a carousel: no dots, no counter, no hint, and the
       track still behaves like a plain image */
    if (slides.length < 2) { if (nav) nav.remove(); return; }

    var cur = 0;
    var dots = [];

    /* --- lazy is measured VERTICALLY, and this track is horizontal ------
       `loading="lazy"` keys off the viewport, and a slide sitting off to the
       right of a scroller counts as out of view however close it is. Measured
       on the live page: slides 3 and 4 reported naturalWidth 0 while 1 and 2
       had loaded, so the first swipe would have landed on a blank cell and
       then popped.

       Fix without giving up laziness: keep the attribute in the markup so a
       lot far below the fold still costs nothing, and promote a track's
       images the moment the LOT itself comes near the viewport. By the time a
       thumb reaches the strip its images are already in flight.

       Setting `loading` from lazy to eager on a not-yet-loaded image starts
       the fetch; that is specified behaviour, not a trick. */
    function wake() {
      [].slice.call(track.querySelectorAll('img[loading="lazy"]'))
        .forEach(function (img) { img.loading = "eager"; });
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { wake(); io.disconnect(); } });
      }, { rootMargin: "600px 0px" });
      io.observe(root);
    } else {
      wake();
    }

    if (nav) {
      var dotWrap = document.createElement("div");
      dotWrap.className = "shots__dots";
      dotWrap.setAttribute("role", "tablist");
      dotWrap.setAttribute("aria-label", "Product photos");

      slides.forEach(function (s, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "shots__dot";
        b.setAttribute("role", "tab");
        b.setAttribute("aria-label", "Photo " + (i + 1) + " of " + slides.length);
        b.addEventListener("click", function () { go(i); });
        dotWrap.appendChild(b);
        dots.push(b);
      });

      var hint = document.createElement("span");
      hint.className = "shots__hint";
      hint.textContent = "Swipe";

      var count = document.createElement("span");
      count.className = "shots__count";

      nav.appendChild(dotWrap);
      nav.appendChild(hint);
      nav.appendChild(count);
      nav.__count = count;
    }

    /* --- ARROWS on the strip (Mudit, 2026-09-25: "need arrows on the right
       and left to show swipability"). Overlaid mid-height on the photo, a
       44px target each. They WRAP, like the lightbox arrows: on a two- or
       three-photo strip a dead end reads as broken. [data-photos-skip] so a
       tap on an arrow moves the strip instead of opening the lightbox. */
    var arrows = document.createElement("div");
    arrows.className = "shots__arrows";
    arrows.setAttribute("data-photos-skip", "");
    [["prev", "Previous photo", -1], ["next", "Next photo", 1]].forEach(function (a) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "shots__arrow shots__arrow--" + a[0];
      b.setAttribute("aria-label", a[1]);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' +
        (a[2] < 0 ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7") + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="square"/></svg>';
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        touched = true;
        /* read the position off the track NOW, not from `cur`: that is updated
           in a requestAnimationFrame, which a backgrounded tab does not run */
        var at = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        go((at + a[2] + slides.length) % slides.length);
      });
      arrows.appendChild(b);
    });
    root.appendChild(arrows);

    var auto = false;   // a programmatic move is not the reader swiping
    function go(i) {
      track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
    }

    /* --- THE DWELL FLIP, on a phone (Mudit, 2026-09-25: "the products dont do
       the flip after a set amount of time we built before?") ------------
       drop-page.js adds `.is-flipped` to a lot 1.5s after it settles in the
       centre band on a touch device, and removes it when it leaves. The plain
       lot's stylesheet turns that into the front/back crossfade; this strip has
       no such rule, so it answers the same class by moving to slide 2 (the
       back), and back to the front when the lot leaves the band. Only until
       the reader touches the strip: after that the strip is theirs. */
    var lot = root.closest(".lot");
    var touched = false;
    track.addEventListener("pointerdown", function () { touched = true; }, { passive: true });
    if (lot && slides.length > 1 && window.MutationObserver) {
      var flipped = false;
      new MutationObserver(function () {
        var now = lot.classList.contains("is-flipped");
        if (now === flipped) return;
        flipped = now;
        if (touched) return;
        auto = true;
        go(now ? 1 : 0);
        setTimeout(function () { auto = false; }, 800);
      }).observe(lot, { attributes: true, attributeFilter: ["class"] });
    }

    function paint(i) {
      cur = i;
      dots.forEach(function (d, n) { d.setAttribute("aria-current", n === i ? "true" : "false"); });
      if (nav && nav.__count) nav.__count.textContent = (i + 1) + "/" + slides.length;
    }
    paint(0);

    /* --- which slide are we on -------------------------------------
       Derived from scrollLeft rather than an IntersectionObserver: the
       track is snap-aligned so the arithmetic is exact, and it costs
       nothing on a strip of four. */
    var raf = null;
    var scrolled = false;
    track.addEventListener("scroll", function () {
      scrolled = true;
      if (!auto) root.classList.add("is-swiped");
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
        if (i !== cur) paint(i);
      });
    }, { passive: true });

    /* --- a swipe is not a tap --------------------------------------
       The strip sits inside [data-photos], so cr-lightbox has a click
       handler on an ancestor. Without this, finishing a swipe with your
       finger still on the image opens the fullscreen viewer, which reads
       as the page grabbing at you. Capture phase, so it runs before the
       lightbox's handler.

       🔴 THE `scroll` FLAG ALONE IS NOT ENOUGH, and testing caught it:
       scroll events are ASYNC, so a click dispatched in the same task as
       the movement arrives while the flag is still false and the viewer
       opened anyway. The reliable signal is SYNCHRONOUS — compare
       scrollLeft at pointerdown against scrollLeft at click. The flag is
       kept as a second condition because momentum scrolling can settle
       back to the same offset it started from. */
    var downX = 0, downLeft = 0;
    track.addEventListener("pointerdown", function (e) {
      scrolled = false;
      downX = e.clientX;
      downLeft = track.scrollLeft;
    }, true);
    track.addEventListener("click", function (e) {
      var moved = Math.abs(track.scrollLeft - downLeft) > 4 ||
                  (e.clientX !== undefined && Math.abs(e.clientX - downX) > 8);
      if (moved || scrolled) {
        e.stopPropagation();
        e.preventDefault();
        scrolled = false;
      }
    }, true);

    /* keyboard: the track is focusable, so arrows should move it */
    track.setAttribute("tabindex", "0");
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(Math.min(slides.length - 1, cur + 1)); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); go(Math.max(0, cur - 1)); }
    });
  });
})();
